module.exports = __webpack_public_path__ + "static/img/ls37.33f4db5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37.png
// module id = Jc8z
// module chunks = 12